import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import OtherEmailTemplateForm from './OtherEmailTemplateForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class OtherEmailTemplate extends Component {
    render() {
        const columns = [
            { label: 'ชื่อ', align: 'left', name: 'name', search_type: 'string' },
            { label: 'ประเภท', align: 'center', name: 'type', search_type: 'string' },
        ];

        const api_url = '/other/emailtemplate';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='Email/SMS' program_type='ข้อมูลตั้งต้นอื่นๆ'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_insert={false} allow_trash={false} allow_active={false} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<OtherEmailTemplateForm {...props} url={api_url}></OtherEmailTemplateForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<OtherEmailTemplateForm {...props} url={api_url}></OtherEmailTemplateForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default OtherEmailTemplate
